import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import keyOn from './key_on'
import { Link } from 'react-router'
import { up } from '../../../../utils/url'
import SearchWidget from '../../../SearchWidget'
import Form from '../settings/Form'

import api from '../../../../api'

@keyOn('params.lead_id')
@inject('leads', 'websites')
@observer
export default class WebsiteLeadEditSearch extends Component {

  state ={
    search: null,
    params: null,
  }

  get lead() {
    return this._lead || (this._lead = this.props.leads.findById(this.props.params.lead_id))
  }

  get website() {
    return this.props.websites.current
  }

  componentDidMount() {
    this.getLead()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.search_id !== nextProps.params.search_id) {
      this.getSearch()
    }
  }

  getLead() {
    this.props.leads.load(this.props.params.lead_id).then(() => this.getSearch())
  }

  getSearch() {
    const { uuid: lead_uuid } = this.lead
    const { uuid: website_uuid } = this.website
    const { search_id } = this.props.params 
    
    this.setState({ search: null })
    api.get(`lead_saved_searches/${search_id}`, { params: { website_uuid, lead_uuid } })
      .then(({ data: search }) => this.setState({ search }))
  }

  handleSearchChange = params => {
    this.setState({ params })
  }

  handleSave = ({ email_frequency }) => {
    const { params } = this.state
    const { uuid: lead_uuid } = this.lead
    const { uuid: website_uuid } = this.website
    const { search_id } = this.props.params 

    return api.put(`lead_saved_searches/${search_id}`, { website_uuid, lead_uuid, params, email_frequency })
  }

  handleDelete = event => {
    event.preventDefault()

    const confirmed = window.confirm('This cannot be undone. Are you sure you want to delete?')
    if (!confirmed) {
      return
    }

    const { uuid: lead_uuid } = this.lead
    const { uuid: website_uuid } = this.website
    const { search_id } = this.props.params

    api.delete(`lead_saved_searches/${search_id}`, { params: { website_uuid, lead_uuid } })
      .then(() => this.props.router.push(`/website/${this.website.id}/leads/${this.lead.id}`))
  }

  render() {
    const { search } = this.state

    if (!search || !this.lead) {
      return <div className="loading">Loading...</div>
    }

    const { uuid: lead_uuid } = this.lead
    const { uuid: website_uuid } = this.website

    return (
      <div className="container padded lead">
        <Form onData={this.handleSave}>
          <div className="panel padded full">
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{fontSize: '2em'}}><span>Editing Search</span> <strong>{search.title}</strong></div>
                <div>
                  Email Frequency:
                  {' '}
                  <select name="email_frequency" defaultValue={search.email_frequency}>
                    <option value="instant">Instant</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="never">Never</option>
                  </select>
                  <a style={{color: 'red', marginLeft: '20px'}} href="#" onClick={this.handleDelete}>Delete</a>
                </div>
              </div>
              <div>Belongs To <Link to={up(2)}>{this.lead.first_name} {this.lead.last_name}</Link></div>
            </div>
          </div>
          <div className="panel padded full">
            <SearchWidget
              website_uuid={website_uuid} 
              lead_uuid={lead_uuid} 
              params={search.params} 
              onChange={this.handleSearchChange} />
          </div>
          <button type="submit" className="big shadowed" disabled={!this.state.params}>Save Changes</button>
        </Form>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// client/components/sections/website/Leads/EditSearch.js